// extracted by mini-css-extract-plugin
export var lg = "_o-4";
export var md = "_o-3";
export var sm = "_o-2";
export var xs = "_o-1";
export var xxs = "_o-0";